import { ReactNode, createContext, use } from 'react'
import { cn } from '../utils'

const DataListOrientationContext = createContext<'grid' | 'vertical'>('grid')

type DataListRootProps = {
  children: ReactNode
  orientation?: 'grid' | 'vertical'
  className?: string
}

export const DataListRoot = ({ children, orientation = 'grid', className }: DataListRootProps) => {
  const orientationClasses = {
    grid: 'grid grid-cols-[auto_1fr] gap-x-1 gap-y-4',
    vertical: 'space-y-4',
  }

  return (
    <DataListOrientationContext value={orientation}>
      <dl className={cn('text-sm', orientationClasses[orientation], className)}>{children}</dl>
    </DataListOrientationContext>
  )
}

type DataListItemProps = {
  label: ReactNode
  children: ReactNode
  highContrast?: boolean
  className?: string
}

export const DataListItem = ({ label, children, highContrast, className }: DataListItemProps) => {
  const orientation = use(DataListOrientationContext)
  const content = (
    <>
      <dt className={cn('min-w-[120px] font-medium text-muted-foreground', highContrast && 'text-foreground')}>
        {label}
      </dt>
      <dd className="overflow-x-auto text-foreground">{children}</dd>
    </>
  )

  if (orientation === 'vertical') {
    return <div className={cn('space-y-1', className)}>{content}</div>
  }

  return content
}
